import { Component, type ErrorInfo, type ReactNode } from "react";

interface State {
  error: Error | null;
}

// Without this the SPA answers any render-time exception with an empty #root, which reads
// as "the screen went blank" and hides the only useful detail — the error message itself.
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Render failed", error, info.componentStack);
  }

  render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="app-crash" role="alert">
        <strong>La pantalla no pudo cargarse</strong>
        <p>Vuelve a cargar la página. Si el problema continúa, comparte este detalle con soporte.</p>
        <code>{error.message}</code>
        <button className="primary-button" type="button" onClick={() => window.location.reload()}>
          Recargar
        </button>
      </div>
    );
  }
}
